import { react2angular } from 'react2angular';
import FiltersPanel from './FiltersPanel';

angular
  .module('analysis.module')
  .component('filtersPanel', react2angular(FiltersPanel, [
    'selection',
    'consistOptions',
    'carOptions',
    'subsystemOptions',
    'eventOptions',
    'envDataFields',
    'envDataFieldValues',
    'envDataFieldMetadata',
    'showConsist',
    'showCars',
    'showSubsystems',
    'showEvents',
    'showDates',
    'dateWindowMode',
    'dateWindowValue',
    'dateWindowUnits',
    'dateWindowDefaultHours',
    'showEnvironmentQuery',
    'showEnvGetDataButton',
    'initiallyCollapseEnvironmentQuery',
    'onSelectionChange',
    'onEnvFiltersChanged',
    'onEnvQueryValidityChange',
    'onDateWindowModeChange',
    'onDateWindowValueChange',
    'onDateWindowReset',
  ]));